import { Stack, Typography } from '@mui/material';

import { AlertTriangleIcon } from '@/components/icons/AlertTriangleIcon';
import {
  AssetIntegrationProviders,
  getIntegrationProviderDisplayName,
} from '@/modules/assetProviderIntegrations/shared/constants';
import { COLORS } from '@/styles/tokens/colors';

export interface InitialIntegrationSyncErrorProps {
  provider: AssetIntegrationProviders;
}

export function InitialIntegrationSyncError({
  provider,
}: InitialIntegrationSyncErrorProps) {
  const ICON_SIZE = 60;
  const providerName = getIntegrationProviderDisplayName(provider);
  return (
    <Stack spacing={5} alignItems="center" justifyContent="center">
      <Stack spacing={2} alignItems="center" justifyContent="center">
        <AlertTriangleIcon size={ICON_SIZE} color={COLORS.TEXT.SECONDARY} />
        <Typography variant="body-s" textAlign="center">
          Unable to retrieve data from {providerName}
        </Typography>
      </Stack>
    </Stack>
  );
}
